module.exports = __webpack_public_path__ + "static/aakarshan-64cc431ba6e59d71f38d8c17a4710248.jpeg";